import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=0fcffa89&scoped=true&"
import script from "./ViewSelector.vue?vue&type=script&lang=js&"
export * from "./ViewSelector.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=0fcffa89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcffa89",
  null
  
)

export default component.exports